module.exports = __webpack_public_path__ + "static/img/title@2x.b57dcc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK_min/title@2x.png
// module id = m4wq
// module chunks = 70